import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
  categoryChip: {
    margin: 5
  }
}));

const CategoryChip = ({label, onDelete, size}) => {
  const classes = useStyles();

  return (
    <Chip
      className={classes.categoryChip}
      size={size || "medium"}
      label={label}
      onDelete={onDelete}
      color="secondary"
    />
  );
};

export default CategoryChip;
